module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level8.b8d730dc.png";